/**
 * Install Page Tabs
 * Tab switching for product tiles and cross-section content visibility.
 */

document.addEventListener('DOMContentLoaded', function () {
  const controllers = document.querySelectorAll('[data-install-page-tabs]');

  controllers.forEach(function (controller) {
    initializeInstallPageTabs(controller);
  });
});

function initializeInstallPageTabs(controller) {
  const tabGroup = controller.dataset.tabGroup;
  const defaultTab = controller.dataset.defaultTab;
  const tabs = controller.querySelectorAll('[data-install-tab]');
  const tabpanels = controller.querySelectorAll('[data-install-tabpanel]');
  const announcer = controller.querySelector('[data-install-tab-announcer]');
  const pageSections = document.querySelectorAll(
    '[data-page-tab-group="' + tabGroup + '"][data-page-tab-content]'
  );

  if (!defaultTab || tabs.length === 0) {
    return;
  }

  function activateTab(tabHandle, options) {
    const settings = options || {};
    const activeTab = Array.prototype.find.call(tabs, function (tab) {
      return tab.dataset.installTab === tabHandle;
    });

    if (!tabHandle || !activeTab) {
      return;
    }

    document.documentElement.dataset.activePageTab = tabHandle;

    tabs.forEach(function (tab) {
      const isActive = tab.dataset.installTab === tabHandle;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    tabpanels.forEach(function (panel) {
      const isActive = panel.dataset.installTabpanel === tabHandle;
      panel.classList.toggle('is-page-tab-active', isActive);
      panel.hidden = !isActive;
    });

    pageSections.forEach(function (section) {
      const isActive = section.dataset.pageTabContent === tabHandle;
      section.classList.toggle('is-page-tab-active', isActive);

      const shopifySection = section.closest('.shopify-section');
      if (shopifySection) {
        if (isActive) {
          shopifySection.removeAttribute('aria-hidden');
        } else {
          shopifySection.setAttribute('aria-hidden', 'true');
        }
      }
    });

    if (
      document.activeElement &&
      document.activeElement.closest('[data-install-tabpanel][hidden]')
    ) {
      activeTab.focus();
    }

    if (announcer && settings.announce !== false) {
      const tabLabel = activeTab.textContent.replace(/\s+/g, ' ').trim();
      announcer.textContent = tabLabel;
    }

    document.documentElement.dataset.pageTabsReady = 'true';
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateTab(this.dataset.installTab);
    });

    tab.addEventListener('keydown', function (event) {
      const tabsArray = Array.prototype.slice.call(tabs);
      const currentIndex = tabsArray.indexOf(event.currentTarget);
      let targetIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        targetIndex = (currentIndex + 1) % tabsArray.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        targetIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
      } else if (event.key === 'Home') {
        event.preventDefault();
        targetIndex = 0;
      } else if (event.key === 'End') {
        event.preventDefault();
        targetIndex = tabsArray.length - 1;
      }

      if (targetIndex === null) {
        return;
      }

      const targetTab = tabsArray[targetIndex];
      targetTab.focus();
      activateTab(targetTab.dataset.installTab);
    });
  });

  activateTab(defaultTab, { announce: false });
}
